// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smallIcon{
    width: 21px;
    height: 21px;
    font-size: 21px;
}
.smallButton{
    width:30px;
    height:30px;
}

:host ::ng-deep .ql-container {
    font-size: 15px;
}

:host ::ng-deep .ql-editor{
    font-size: 15px;
    min-height: 80px;
    
}

:host ::ng-deep quill-view .ql-editor{
    font-size: 15px;
    min-height: 20px;
    padding: 0px;
}



.center {
    display: flex;
    align-items: center;
    justify-content: center;
}


p {
    width: 100%;
    max-width: none !important;
}
/* :host ::ng-deep .mat-form-field-wrapper {
    padding: 0px !important
} */

/* :host ::ng-deep .mat-form-field-inifix {
    padding: 0px !important
} */

:host ::ng-deep .activity_note .ql-editor{
    font-size: 15px;
    min-height: 0px;
    padding: 2px;
    max-height: 220px;
    overflow: scroll;
}`, "",{"version":3,"sources":["webpack://./src/app/contact-detail/contact-detail.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;;AAGA;IACI,WAAW;IACX,0BAA0B;AAC9B;AACA;;GAEG;;AAEH;;GAEG;;AAEH;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":[".smallIcon{\n    width: 21px;\n    height: 21px;\n    font-size: 21px;\n}\n.smallButton{\n    width:30px;\n    height:30px;\n}\n\n:host ::ng-deep .ql-container {\n    font-size: 15px;\n}\n\n:host ::ng-deep .ql-editor{\n    font-size: 15px;\n    min-height: 80px;\n    \n}\n\n:host ::ng-deep quill-view .ql-editor{\n    font-size: 15px;\n    min-height: 20px;\n    padding: 0px;\n}\n\n\n\n.center {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n\np {\n    width: 100%;\n    max-width: none !important;\n}\n/* :host ::ng-deep .mat-form-field-wrapper {\n    padding: 0px !important\n} */\n\n/* :host ::ng-deep .mat-form-field-inifix {\n    padding: 0px !important\n} */\n\n:host ::ng-deep .activity_note .ql-editor{\n    font-size: 15px;\n    min-height: 0px;\n    padding: 2px;\n    max-height: 220px;\n    overflow: scroll;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
